import React from 'react';
import estilos from './sliders.module.css'

function Sliders({ imagenes, titulo }, {}) {
    const [imagenActual, setImagenActual] = React.useState(0);
    const cantidad = imagenes?.length;

    // Return prematuro para evitar errores
    if (!Array.isArray(imagenes) || cantidad === 0)
        return;

    const siguienteImagen = () => {
        setImagenActual(imagenActual === cantidad - 1 ? 0 :
            imagenActual + 1);
    };

    const anteriorImagen = () => {
        setImagenActual(imagenActual === 0 ? cantidad - 1 :
            imagenActual - 1);
    }
    return (
        <div>
            <h2>{titulo}</h2>
            <div className={estilos.container}>
                <button onClick={anteriorImagen}>⬅</button>
                {imagenes.map((imagen, index) => {
                    return (
                        <div key={index}>
                            {imagenActual === index && (
                            <img key={index} src={imagen} alt="imagen" className='imagen-sliders' />
                            )}
                        </div>
                    );
                })}
                <button onClick={siguienteImagen}>➡</button>
            </div>
        </div>
    )
}

export default Sliders